import { Tab as MuiTab } from '@material-ui/core'
import styled from 'styled-components'
import theme from '../theme'

const Tab = styled(MuiTab)`
  &.MuiTab-root {
    text-transform: initial;
    border-bottom: 3px solid ${theme.palette.divider};

    font-family: ${theme.typography.fontFamily};
    font-size: 0.875rem;

    opacity: 1;
  }

  .MuiTab-wrapper {
    color: ${theme.palette.grey[700]};
  }

  &.Mui-selected {
    border-bottom-color: ${theme.palette.primary.main};
  }
  &.Mui-selected .MuiTab-wrapper {
    color: ${theme.palette.primary.main};
  }
`

export default Tab
